import React from 'react';
// Helpers
import { withCDN } from 'helpers/cdn';
// Ui
import Image from 'ui/Image/Image';
// Components
import Divider from 'ui/Divider/Divider';
// Icons
import AvionIcon from '../../../public/images/icons/avion.svg';
import LinkedinIcon from '../../../public/images/icons/linkedin.svg';

import styles from './OurTeam.module.scss';

const members = [
  {
    name: 'Matt Whitteker',
    position: 'Co-Founder CEO',
    email: 'matt@millions.co',
    linkedIn: 'https://www.linkedin.com/in/matt-whitteker-06596011',
    image: withCDN('/images/about-us/MattWhitteker.jpg'),
  },
  {
    name: 'Adrian Salamunovic',
    position: 'Co-Founder Advisor',
    email: 'adrian@millions.co',
    linkedIn: 'https://www.linkedin.com/in/adriansalamunovic',
    image: withCDN('/images/about-us/AdrianSalamunovic.jpg'),
  },
  {
    name: 'Scott Whitteker',
    position: 'Co-Founder Advisor',
    email: 'scott@millions.co',
    linkedIn: 'https://www.linkedin.com/in/scott-whitteker-75b28313b',
    image: withCDN('/images/about-us/ScottWhitteker.jpg'),
  },
  {
    name: 'Brandon Austin',
    position: 'Co-Founder CMO',
    email: 'brandon@millions.co',
    linkedIn: 'https://www.linkedin.com/in/baustin1992/',
    image: withCDN('/images/about-us/BrandonAustin.png'),
  },
];

export const OurTeam: React.FC = () => {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <h3 className={styles.title}>MEET OUR TEAM</h3>
        <Divider className={styles.divider} />
        <ul className={styles.list}>
          {members.map(({ name, position, image, email, linkedIn }) => (
            <li key={name} className={styles.listItem}>
              <div className={styles.imageWrapper}>
                <Image
                  src={image}
                  className={styles.image}
                  alt={`${name} ${position}`}
                />
              </div>
              <div className={styles.member}>
                <p className={styles.name}>{name}</p>
                <span className={styles.position}>{position}</span>
                <a href={`mailto:${email}`} className={styles.link}>
                  <AvionIcon
                    className={styles.linkIcon}
                    width={24}
                    height={24}
                    role="presentation"
                    focusable="false"
                  />
                  {email}
                </a>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href={linkedIn}
                  className={styles.link}
                >
                  <LinkedinIcon
                    className={styles.linkIcon}
                    width={24}
                    height={24}
                    role="presentation"
                    focusable="false"
                  />
                  {name}
                </a>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};
